// import React from 'react'
// import { Outlet } from 'react-router-dom'
// import {Headers, Footer} from '../index'
// import EnquiryButton from './EnquiryButton'

// const LandingPageLayout = () => {
//   return (

//     <div className="site-wrapper">
//     <Headers />
//     <EnquiryButton/>

//     <Outlet/>
    
//     <Footer/>
   
//     </div>
//   )
// }

// export default LandingPageLayout


import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import {Headers, Footer} from '../index'
import EnquiryButton from './EnquiryButton'

const LandingPageLayout = () => {
  const location = useLocation();
  const hideHeader = location.pathname === '/finance';
  const hideFooter = location.pathname === '/finance';

  return (

    <div className="site-wrapper">
    {!hideHeader && <Headers />}

    {!hideHeader && <EnquiryButton />}

    <Outlet/>

    {!hideFooter && <Footer/>}

    </div>
  )
}

export default LandingPageLayout